import styled, {css} from "styled-components";
import checkbox from 'src/assets/images/mkt04/checkbox.svg'
import nonCheckbox from 'src/assets/images/mkt04/nonCheckbox.svg'

export const KTMVNOPopupWrap = styled.div`
    display: flex;
    flex-flow: column;
    gap: 12px;
`;
export const TermsCheckBoxWrap = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    &>input {
        position: absolute !important;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0 0 0 0);        
        clip-path: inset(50%);      
        white-space: nowrap;
        border: 0;
        &:focus-visible + label .icon {
            outline: 2px solid #1a6eff;
            outline-offset: 2px;
            border-radius: 4px;
        }
    }
    
`

export const TermsCheckBox = styled.label<{ isChecked: boolean; disabled?: boolean }>`
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;        
    gap: 10px;
    width: 100%;
    padding: 15px 16px;
    border-radius: 12px;
    background-color: #fafafa;
    cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
    p {
        margin: 0;
        font-family: ${({ theme }) => theme.fontFamily};
        font-size: 14px;
        font-weight: 400;
        color: #717580;
    }

    .icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;

        ${({isChecked, disabled}) => {
            if (disabled) {
                return css`background-image: url(${isChecked ? checkbox : nonCheckbox});`;
            }
            return css`background-image: url(${isChecked ? checkbox : nonCheckbox});`;
        }}
    }
`;